import TimeRemainingText from './TimeRemainingText';
export default TimeRemainingText;
